import { render, staticRenderFns } from "./Resposta.vue?vue&type=template&id=7cd92d70&"
import script from "./Resposta.vue?vue&type=script&lang=ts&"
export * from "./Resposta.vue?vue&type=script&lang=ts&"
import style0 from "./Resposta.vue?vue&type=style&index=0&id=7cd92d70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports